import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const eventTypesApi = createApi({
    reducerPath: 'eventTypesApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getEventTypes: build.query({
            query: ({ queryOptions, ...params }) => ({
                url: api.events.types.getEventTypes(),
                method: 'GET',
                params,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
        }),
        createEventType: build.mutation({
            query: (data) => ({
                url: api.events.types.createEventType(),
                method: 'POST',
                body: data
            }),
        }),
    })
})

export const { useLazyGetEventTypesQuery, useCreateEventTypeMutation } = eventTypesApi
